import { Controller } from "@hotwired/stimulus";
import Swiper from "swiper";
import { Navigation, Thumbs, FreeMode } from "swiper/modules";

// Connects to data-controller="product-gallery"
export default class extends Controller {
  static targets = ["main", "thumbs", "video"];
  static values = { totalSlides: Number };

  connect() {
    const hasThumbs = this.hasThumbsTarget;
    const total = this.totalSlidesValue || 0;

    // Create thumbs swiper first (if exists)
    this.thumbsSwiper = hasThumbs
      ? new Swiper(this.thumbsTarget, {
          modules: [FreeMode],
          loop: false,
          spaceBetween: 10,
          slidesPerView: 4,
          freeMode: true,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
          breakpoints: {
            0: { slidesPerView: 3 },
            480: { slidesPerView: 4 },
          },
        })
      : null;

    // Main swiper
    this.mainSwiper = new Swiper(this.mainTarget, {
      modules: [Navigation, Thumbs],
      loop: false,
      spaceBetween: 10,
      preloadImages: false,
      lazyPreloadPrevNext: 1,
      navigation: {
        nextEl: this.element.querySelector(".swiper-button-next"),
        prevEl: this.element.querySelector(".swiper-button-prev"),
      },
      thumbs: this.thumbsSwiper ? { swiper: this.thumbsSwiper } : undefined,
    });

    // Pause videos on slide change
    this.mainSwiper.on("slideChangeTransitionStart", () => this.pauseVideos());

    // Hide nav if only one slide
    if (total <= 1) {
      const prev = this.element.querySelector(".swiper-button-prev");
      const next = this.element.querySelector(".swiper-button-next");
      if (prev) prev.style.display = "none";
      if (next) next.style.display = "none";
    }
  }

  disconnect() {
    if (this.mainSwiper) this.mainSwiper.destroy(true, false);
    if (this.thumbsSwiper) this.thumbsSwiper.destroy(true, false);
  }

  // Pause any playing videos when slide changes
  pauseVideos() {
    if (!this.videoTarget.paused) {
      this.videoTarget.pause();
    }
  }
}
